export default __webpack_public_path__ + "static/media/logo-dtt-big.7c94d393.png";